exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-image-wrappers[data-v-01b58577]{display:grid;grid-template-columns:repeat(4,1fr);grid-gap:.8rem}.product-image-wrapper[data-v-01b58577]{position:relative}.product-image-wrapper[data-v-01b58577] .product-image{margin-right:0!important}.product-image-wrapper[data-v-01b58577] button.btn-danger{position:absolute;top:.5rem;right:.5rem;opacity:0;transition:.2s ease-out}.product-image-wrapper[data-v-01b58577]:hover button.btn-danger{opacity:1}", ""]);

// exports
